import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import eventSource from './modules/eventSource'
import bug from './modules/bug'
import dict from './modules/dict'
import user from './modules/user'
import tagsView from './modules/tagsView'
import permission from './modules/permission'
import settings from './modules/settings'
import getters from './getters'
import iframes from "./modules/iframes"
// import iframeConfig from './modules/iframeConfig'
import socCanvas from './modules/socCanvas'
import bspGenerator from './modules/bspGenerator'
import pinout from './pinout/pinout'
import pinmux from './modules/pinmux'
import autoSAR from './modules/autoSAR';

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    eventSource,
    bug,
    dict,
    user,
    tagsView,
    permission,
    settings,
    iframes,
    socCanvas,
    bspGenerator,
    pinout,
    pinmux,
    autoSAR
  },
  getters
})

export default store
